export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    download({ dispatch }, { response, type, name = 'descarga' }) {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(new Blob([response.data]))
      const typeParts = type.toLowerCase().split('-')
      const typeFormatted = typeParts[0]
      const nameFormatted = `${name}${typeParts.length > 1 ? `-${typeParts[1]}` : ''}`
      switch (typeFormatted) {
        case 'excel':
          link.setAttribute('download', `${nameFormatted}.xlsx`)
          break
        default:
          link.setAttribute('download', `${nameFormatted}.pdf`)
          break
      }
      document.body.appendChild(link)
      link.click()
      dispatch(
        'setSnackbar',
        {
          tipo: 'success',
          mensaje: `Informe ${type} descargado correctamente.`,
        },
        {
          root: true,
        }
      )
    },
  },
}
